// IE 2026 10 17 / ODOO-5800 (бой 17.10, бот 3/3: форма политики 0GJ_001 → Затвердження → Умови/Кроки → Переходи: грид переходов ПУСТ при 43 строках в записи,
// бейдж 43, переключением вкладок не чинится; инструментированный прогон dev02 handoff-tools/2026-10-17/tabgrid_empty): страница стола живёт в <keep-alive>
// роутера (App.vue, ключ routeViewKey = path + query без process_model). URL без page= (или с другим набором query) → приложение дописывает page= →
// ВТОРОЙ экземпляр Page того же стола и той же страницы, а первый остаётся в кэше KeepAlive ДЕАКТИВИРОВАННЫМ, но живым и реактивным: его MainArea
// продолжает рендерить виджеты стора (общие объекты WIDGET), в т.ч. открытые позже. Открытие ленивой вкладки создаёт в отцепленном DOM этой страницы
// ВТОРЫЕ экземпляры AttrTabPanel/AttrGrid того же attr_id, и они перезаписывают реестр WIDGET.attrs_vueObj (widget_attr_set — «последний победил»):
// рассылка content_Changed с данными и lazyTab_afterData уходят невидимому клону, а грид на экране остаётся пустым. Исход зависит от того, успел ли ответ
// бэка (~350 мс на бою) ДО создания клона (~470 мс после клика) — отсюда «иногда».
// Правило (флаг fe.ux.stalePageGuard, по умолчанию ВКЛ): (а) компонент из поддерева ДЕАКТИВИРОВАННОЙ KeepAlive-страницы в реестры
// attrs_vueObj / _attrsLive / WIDGET.vueObj не пишется (inDeactivatedTree: цепочка внутренних экземпляров Vue до корня, isDeactivated ставит KeepAlive);
// (б) MainArea деактивированной страницы не подхватывает НОВЫЕ виджеты (открытые после деактивации) — только те, что уже были смонтированы;
// при активации страницы — как раньше, все виджеты её страницы. Тест: tests/unit/stalePage.test.mjs
export const STALE_PAGE_GUARD_FLAG = 'fe.ux.stalePageGuard'

export function stalePageGuard_on(setting) {
    try { return typeof setting !== 'function' || setting(STALE_PAGE_GUARD_FLAG, true) !== false } catch (e) { return true }
}

// true — компонент лежит в поддереве деактивированного (кэшированного KeepAlive) компонента. vm — публичный прокси (vm.$ — внутренний экземпляр)
// или сам внутренний экземпляр ({ parent, isDeactivated })
export function inDeactivatedTree(vm) {
    try {
        let c = vm && vm.$ && typeof vm.$ === 'object' && 'parent' in vm.$ ? vm.$ : vm
        for (let guard = 0; c && typeof c === 'object' && guard < 500; c = c.parent, guard++) {
            if (c.isDeactivated === true) return true
        }
    } catch (e) { /* не компонент */ }
    return false
}

// виджеты, которые рендерит MainArea: активная страница — все; деактивированная — только смонтированные до деактивации (frozenIds: Set id)
export function staleWidgets_filter(widgets, pageActive, frozenIds) {
    const list = Array.isArray(widgets) ? widgets : []
    if (pageActive || !(frozenIds instanceof Set)) return list
    return list.filter(w => w && frozenIds.has(w.id))
}
